import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TResetPost, EResetPostActionType } from './types';

export const resetPost: () => TResetPost = actionGenerator<EResetPostActionType.Reset>(EResetPostActionType.Reset);
